import './styles.css'

import Lock from '@assets/icons/lock-animated.svg'
import { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import useLimitExceeded from '@/hooks/useLimitExceeded'

export default function ConsultationLimitExceededWrapper({ children }: PropsWithChildren) {
  const { t } = useTranslation()
  const { limitExceeded } = useLimitExceeded()

  return (
    <div className="relative flex grow">
      {children}

      {limitExceeded && (
        <div id="gradient-container" className="animate-fade-in absolute top-0 left-0 z-10 flex h-full w-full items-center justify-center">
          <div className="flex flex-col gap-12 p-8">
            <img src={Lock} alt="Lock" className="mx-auto w-24" />
            <p className="text-center" dangerouslySetInnerHTML={{ __html: t('upgrade.description')! }} />
          </div>
        </div>
      )}
    </div>
  )
}
